import ChangeScene from '../change-scenes/change-scene.entity';
import { DEPARTMENTS } from '../enums/enums';
import HaChangeScene from '../ha-change-scenes/ha-change-scene.entity';
import MuChangeScene from '../mu-change-scenes/mu-change-scene.entity';
import Scene from '../scenes/scene.entity';
import { SosGetResponse } from '../sos-response';

export interface DeptSpecificChangeSceneGetResponse<T extends DEPARTMENTS>
	extends SosGetResponse {
	listed: T extends DEPARTMENTS.CM
		? {
				ChangeScene: ChangeScene[];
				Scene?: Scene[];
		  }
		: T extends DEPARTMENTS.HA
		? {
				HaChangeScene: HaChangeScene[];
				Scene?: Scene[];
		  }
		: T extends DEPARTMENTS.MU
		? {
				MuChangeScene: MuChangeScene[];
				Scene?: Scene[];
		  }
		: never;
}

export type ChangeSceneGetResponse =
	| DeptSpecificChangeSceneGetResponse<DEPARTMENTS.CM>
	| DeptSpecificChangeSceneGetResponse<DEPARTMENTS.HA>
	| DeptSpecificChangeSceneGetResponse<DEPARTMENTS.MU>;
